// useReceivableDetail.ts

import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../../../store/store";

import useLoading from "../../../../hooks/useLoading";

import ReceivableDetailService from "../services/receivableDetail.service";

import {
  clearReceivableDetail,
  closeDetailModal,
  openDetailModal,
  setError,
  setLoading,
  setReceivableDetail,
} from "../store/receivableDetail.slice";

export const useReceivableDetail = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    showLoadingIndicator,
    hideLoadingIndicator,
  } = useLoading();

  const {
    detail,
    loading,
    error,
    isModalOpen,
    selectedReceivableId,
  } = useSelector(
    (state: RootState) => state.receivableDetail
  );

  /**
   * 📌 Obtener detalle por ID
   */
  const fetchReceivableDetail = async (
    receivableId: number
  ) => {
    try {
      dispatch(setLoading(true));
      showLoadingIndicator();

      const data =
        await ReceivableDetailService.getById(
          receivableId
        );

        console.log(data);

      dispatch(setReceivableDetail(data));

      return data;
    } catch (err: any) {
      dispatch(
        setError(
          "Error al obtener detalle de cuenta por cobrar"
        )
      );

      dispatch(clearReceivableDetail());

      return null;
    } finally {
      dispatch(setLoading(false));
      hideLoadingIndicator();
    }
  };

  /**
   * 🪟 Abrir modal + cargar detalle
   */
  const handleOpenDetailModal = async (
    receivableId: number
  ) => {
    dispatch(openDetailModal(receivableId));

    await fetchReceivableDetail(receivableId);
  };

  /**
   * ❌ Cerrar modal + limpiar state
   */
  const handleCloseDetailModal = () => {
    dispatch(closeDetailModal());
    dispatch(clearReceivableDetail());
  };

  /**
   * 🧹 limpieza manual
   */
  const clearDetail = () => {
    dispatch(clearReceivableDetail());
  };

  return {
    // state
    detail,
    loading,
    error,
    isModalOpen,
    selectedReceivableId,

    // actions
    fetchReceivableDetail,
    handleOpenDetailModal,
    handleCloseDetailModal,
    clearDetail,
  };
};